import { Box, Button, ButtonGroup, HStack, IconButton } from "@chakra-ui/react";
import RefreshOutlined from "../../assets/icons/Refresh";

type IProps = {
  showCheck: boolean;
  isCheckDisabled: boolean;
  showTryAgain: boolean;
  showExplanation: boolean;
  showReset: boolean;
  explanantionOnClick?: () => void;
  onCheckClick?: (e: any) => void;
  resetOnClick?: () => void;
  onTryAgainClick?: () => void;
};

const Control = ({
  showCheck,
  showTryAgain,
  isCheckDisabled,
  showExplanation,
  onCheckClick,
  showReset,
  explanantionOnClick,
  resetOnClick,
  onTryAgainClick,
}: IProps) => {
  return (
    <HStack mt="1rem" justifyContent="space-between">
      <ButtonGroup>
        {showCheck && (
          <Button
            onClick={onCheckClick}
            size="md"
            variant="solid"
            color="black"
            bg="white"
            isDisabled={isCheckDisabled}
          >
            Check
          </Button>
        )}
        {showTryAgain ? (
          <Button onClick={onTryAgainClick} variant="outline">
            Try again
          </Button>
        ) : (
          <Button size={"md"} variant="outline" onClick={explanantionOnClick}>
            {showExplanation ? "Hide Explanation" : "Show Explanation"}
          </Button>
        )}
      </ButtonGroup>
      <Box>
        {showReset && (
          <>
            <Button
              display={{ base: "none", sm: "block" }}
              size={"md"}
              variant="ghost"
              onClick={resetOnClick}
            >
              Reset
            </Button>
            <IconButton
              display={{ base: "block", sm: "none" }}
              size={"md"}
              variant={"ghost"}
              onClick={resetOnClick}
              icon={<RefreshOutlined />}
              aria-label="restart"
            ></IconButton>
          </>
        )}
      </Box>
    </HStack>
  );
};

export default Control;
